import WPContent from "../WPContent";
import styles from "./Gutenberg.module.css";

interface PropT {
    conteudo: string
}

const Gutenberg = ({ conteudo }: PropT) => {
    return (
        <div className={styles.wrapper}>
            <WPContent conteudo={conteudo} />
        </div>
    );
}

export default Gutenberg;